"use strict";
exports.__esModule = true;
exports.initialReduxState = void 0;
var payment_details_1 = require("./modules/payment-details");
var user_account_1 = require("./modules/user-account");
var onboarding_status_1 = require("./modules/onboarding-status");
var prefills_1 = require("./modules/prefills");
var feature_status_1 = require("./modules/feature-status");
var wallet_balance_1 = require("./modules/wallet-balance");
var eligibility_check_1 = require("./modules/eligibility-check");
var device_metadata_1 = require("./modules/device-metadata");
var property_linking_1 = require("./modules/property-linking");
var embed_1 = require("./modules/embed");
// TODO add typings for the rest of the reducers
exports.initialReduxState = {
    userAccount: user_account_1.userAccountInitialState,
    paymentDetails: payment_details_1.paymentDetailsInitialState,
    onboardingStatus: onboarding_status_1.onboardingStatusInitialState,
    prefills: prefills_1.prefillsInitialState,
    featureStatus: feature_status_1.featureStatusInitialState,
    walletBalance: wallet_balance_1.walletBalanceInitialState,
    eligibilityCheck: eligibility_check_1.eligibilityCheckInitialState,
    deviceMetadata: device_metadata_1.deviceMetadataInitialState,
    propertyLinking: property_linking_1.propertyLinkingInitialState,
    embed: embed_1.embedInitialState
};
